import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/ui/password-input";
import { Loader2, AlertCircle } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PhoneLoginForm } from "@/components/auth/PhoneLoginForm";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { TermsAcceptance } from "@/components/auth/TermsAcceptance";
import { useRegisterState } from '@/hooks/auth/useRegisterState';

const Register = () => {
  const {
    isAuthenticated,
    form,
    handleChange,
    validateForm,
    isLoading,
    termsAccepted,
    activeTab,
    error,
    setTermsAccepted,
    setActiveTab,
    handleSubmit
  } = useRegisterState();
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
      <div className="w-full max-w-md">
        <Card className="shadow-lg">
          <CardHeader className="space-y-1">
            <CardTitle className="text-2xl text-center">Регистрация</CardTitle>
            <CardDescription className="text-center">
              Создайте учетную запись для доступа к системе
            </CardDescription>
          </CardHeader>
          <CardContent>
            {error && (
              <Alert variant="destructive" className="mb-4">
                <AlertCircle className="h-4 w-4" />
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}
            
            <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
              <TabsList className="grid grid-cols-2 w-full mb-6">
                <TabsTrigger value="email">Email</TabsTrigger>
                <TabsTrigger value="phone">Телефон</TabsTrigger>
              </TabsList>
              
              <TabsContent value="email">
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="space-y-2">
                    <Label htmlFor="fullName">Полное имя</Label>
                    <Input
                      id="fullName"
                      name="fullName"
                      placeholder="Иван Петров"
                      value={form.fullName.value}
                      onChange={handleChange}
                      className={form.fullName.error && form.fullName.touched ? "border-destructive" : ""}
                    />
                    {form.fullName.error && form.fullName.touched && (
                      <p className="text-sm text-destructive">{form.fullName.error}</p>
                    )}
                  </div>
                  
                  <div className="space-y-2">
                    <Label htmlFor="email">Email</Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="example@mail.com"
                      value={form.email.value}
                      onChange={handleChange}
                      className={form.email.error && form.email.touched ? "border-destructive" : ""}
                    />
                    {form.email.error && form.email.touched && (
                      <p className="text-sm text-destructive">{form.email.error}</p>
                    )}
                  </div>
                  
                  <div className="space-y-2">
                    <Label htmlFor="password">Пароль</Label>
                    <PasswordInput
                      id="password"
                      name="password"
                      placeholder="••••••••"
                      value={form.password.value}
                      onChange={handleChange}
                      error={!!(form.password.error && form.password.touched)}
                    />
                    {form.password.error && form.password.touched ? (
                      <p className="text-sm text-destructive">{form.password.error}</p>
                    ) : (
                      <p className="text-xs text-muted-foreground mt-1">
                        Пароль должен содержать минимум 8 символов, одну заглавную букву, одну строчную букву, одну цифру и один специальный символ
                      </p>
                    )}
                  </div>
                  
                  <div className="space-y-2">
                    <Label htmlFor="confirmPassword">Подтвердите пароль</Label>
                    <PasswordInput
                      id="confirmPassword"
                      name="confirmPassword"
                      placeholder="••••••••"
                      value={form.confirmPassword.value}
                      onChange={handleChange}
                      error={!!(form.confirmPassword.error && form.confirmPassword.touched)}
                    />
                    {form.confirmPassword.error && form.confirmPassword.touched && (
                      <p className="text-sm text-destructive">{form.confirmPassword.error}</p>
                    )}
                  </div>
                  
<TermsAcceptance
                      id="terms"
                      checked={termsAccepted}
                      onCheckedChange={setTermsAccepted}
                    />
                  
                  <Button type="submit" className="w-full" disabled={isLoading}>
                    {isLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
                    Зарегистрироваться
                  </Button>
                </form>
              </TabsContent>
              
              <TabsContent value="phone">
                <div className="space-y-4">
                  <PhoneLoginForm />
                  
<TermsAcceptance
                      id="terms-phone"
                      checked={termsAccepted}
                      onCheckedChange={setTermsAccepted}
                    />
                </div>
              </TabsContent>
              
            </Tabs>
          </CardContent>
          <CardFooter className="flex flex-col space-y-2 text-center">
            <div className="text-sm">
              Уже есть учетная запись?{" "}
              <Link to="/login" className="text-primary hover:underline">
                Войти
              </Link>
            </div>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};

export default Register;
